/* prettier-ignore */

import { Component, computed, effect, ElementRef, HostListener, inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MapCustomRouteComponent } from './components/map/map.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { NewCustomRouteService } from './new-custom-route.service';
import { CommonModule } from '@angular/common';
import { RouteFooterComponent } from './components/footer/footer.component';
import { Router } from '@angular/router';
import { SendUpdateRouteService } from '../send-update-route/send-update-route.service';
import { ToolsService } from 'src/app/services/tools.service';
import { dataChatService } from 'src/chatbot/service/dataChat.service';

@Component({
    selector: 'new-custom-route',
    imports: [
        CommonModule,
        MapCustomRouteComponent,
        TimelineComponent,
        RouteFooterComponent,
    ],
    standalone: true,
    templateUrl: './new-custom-route.page.html',
    styleUrls: ['./new-custom-route.page.scss'],
    encapsulation: ViewEncapsulation.None
})


export class NewCustomRoutePage {
    @ViewChild('timelinePane', { static: false }) timelinePane!: ElementRef;
    @ViewChild('mapPane', { static: false }) mapPane!: ElementRef;
    @ViewChild('resizer', { static: false }) resizer!: ElementRef;
    public dataChatService = inject(dataChatService);
    private routeService = inject(NewCustomRouteService);
    private sendUpdateService = inject(SendUpdateRouteService);
    private tools = inject(ToolsService)
    private router = inject(Router);
    public showTimeline = computed(() => this.routeService.showTimeline());
    public route = computed(() => this.routeService.route());
    private isResizing = false;
    private startX = 0;
    private startLeftWidth = 0;
    private containerWidth: any;
    private resizerWidth: any;
    private animationFrameId: number | null = null; 

    private saveCurrentRouteOnLocalStorage = effect(() => {
        const currentRoute = this.route();
        if (currentRoute?.length === 0)
            return

        const twoHours = 1000 * 3600 * 2;
        this.tools.setWithExpiry('customRoute', currentRoute, twoHours);
        setTimeout(() => {
            this.checkResize();
        }, 250);
    });

    constructor(){
        if (!this.route()){
            // const localStorageRoute = this.tools.getWithExpiry('customRoute');
            // if (localStorageRoute && localStorageRoute?.length){
            //     this.routeService.route.set(localStorageRoute);
            //     // this.routeService.filterAppItems();
            //     return;
            // }

            this.router.navigateByUrl('/home');
        }
    }

    ngOnInit(){
        // this.dataChatService.hideChat.set(true);
        this.sendUpdateService.loadInitialData();
    }

    checkResize(){
        const size = document.querySelector('.cards-container')?.clientWidth;
        if (!size || !this.timelinePane)
            return;

        this.timelinePane.nativeElement.style.maxWidth = `${size}px`;
    }

    ngAfterViewInit(){
        setTimeout(() => {
            this.checkResize();
        }, 50);
    }

    startResizing(event: MouseEvent) {
        this.isResizing = true;
        this.startX = event.clientX;
        this.startLeftWidth = this.timelinePane.nativeElement.offsetWidth;
        this.containerWidth = this.resizer.nativeElement.parentElement.offsetWidth;
        this.resizerWidth = this.resizer.nativeElement.offsetWidth;

        document.body.style.userSelect = 'none';
        document.body.style.pointerEvents = 'none';

        document.addEventListener('mousemove', this.handleMouseMove, { passive: true });
        document.addEventListener('mouseup', this.stopResizing, { passive: true });
    }

    handleMouseMove = (event: MouseEvent) => {
        if (!this.isResizing) return;

        const deltaX = event.clientX - this.startX;
        let newLeftWidth = this.startLeftWidth + deltaX;
        let rightWidth = this.containerWidth - newLeftWidth - this.resizerWidth;

        const maxLeftWidth = this.timelinePane.nativeElement.style.maxWidth 
            ? parseInt(this.timelinePane.nativeElement.style.maxWidth, 10)
            : this.containerWidth - 100;

        if (newLeftWidth < 220) newLeftWidth = 220;
        if (newLeftWidth > maxLeftWidth) newLeftWidth = maxLeftWidth;

        rightWidth = this.containerWidth - newLeftWidth - this.resizerWidth;
        if (rightWidth < 400) {
            rightWidth = 400;
            newLeftWidth = this.containerWidth - rightWidth - this.resizerWidth;
        }

        if (this.animationFrameId) 
            cancelAnimationFrame(this.animationFrameId);

        this.animationFrameId = requestAnimationFrame(() => {
            this.timelinePane.nativeElement.style.width = `${newLeftWidth}px`;
            this.timelinePane.nativeElement.style.minWidth = `${newLeftWidth}px`;
            this.mapPane.nativeElement.style.width = `100%`;
        });
    };

    stopResizing = () => {
        this.isResizing = false;
        document.body.style.userSelect = '';
        document.body.style.pointerEvents = '';

        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.stopResizing);

        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
    };

}